import { previewCurrency } from '../constants'

export const getWidgetPreviewSettings = appearance => {
  return {
    show_detail_modal: true,
    widget_background_color: appearance.widget_background_color,
    widget_text_color: appearance.widget_text_color,
    widget_link_color: appearance.widget_link_color,
    popup_overlay_color: appearance.popup_overlay_color,
    popup_header_text_color: appearance.popup_header_text_color,
    popup_body_text_color: appearance.popup_body_text_color,
    popup_header_image_url: appearance.popup_header_image_url,
    decline_action_style: appearance.decline_action_style,
  }
}

export const getPreviewCurrency = store => {
  if (!store.currency) return previewCurrency

  return store.currency
}

export const getFieldError = (fieldErrors, field) => fieldErrors[field]?.join(' ')
